
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat, toLower, toCapital } from '../../helpers/formatter';
import { setTitle, setSpinner, setTopbarMenu, hideSidebar, hideTopbarMenu, registerTopbarLeft } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
import SubTestReduxObj from '../../redux/SubTest';
import RBtnTrackingReduxObj from '../../redux/RBtnTracking';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';
import moment from 'moment';
import { isEmpty, isNotEmpty } from '../../helpers/utils';

class Dashboard extends RintagiScreen {
  constructor(props) {
    super(props);
    this.GetReduxState = () => (this.props.VwRUsrSubDtl || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'UsrSubsId4';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);

    this.props.registerTopbarLeft("","",true,"","");
    this.props.hideSidebar(false);
    this.props.hideTopbarMenu(false);

    // this.props.setTopbarMenu(true);

    this.state = {
      submitting: false,
      ScreenButton: null,
      key: '',
      Buttons: {},
      ModalColor: '',
      ModalTitle: '',
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      ModalCancel: null,
      isMobile: false,
      // reduxRefreshed: false
    }

    Promise.all([
      this.props.LoadPage('MstRecord', { mstId: '!' }),
    ]).catch(error => {
      
    }).finally(() => {
      // this.setState({ reduxRefreshed: true });
      setTimeout(() => this.props.setSpinner(false), 500);
      
    })

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }

    if (!this.props.suppressLoadPage) {
      this.props.setSpinner(true, 'dash-1');
    }
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  /* react related stuff */
  static getDerivedStateFromProps(nextProps, prevState) {
    const nextReduxScreenState = nextProps.SubTest || {};
    const buttons = nextReduxScreenState.Buttons || {};
    const revisedButtonDef = super.GetScreenButtonDef(buttons, 'Mst', prevState);
    const currentKey = nextReduxScreenState.key;
    const waiting = nextReduxScreenState.page_saving || nextReduxScreenState.page_loading;
    let revisedState = {};
    if (revisedButtonDef) revisedState.Buttons = revisedButtonDef;

    if (prevState.submitting && !waiting && nextReduxScreenState.submittedOn > prevState.submittedOn) {
      prevState.setSubmitting(false);
    }

    return revisedState;
  }

  confirmUnload(message, callback) {
    const SubTestState = this.props.SubTest || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'warning', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  componentDidMount() {
    this.once = true;
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    const suppressLoadPage = this.props.suppressLoadPage;
    if (!suppressLoadPage) {
      const { mstId } = { ...this.props.match.params };
      // if (!(this.props.SubTest || {}).AuthCol || true) {
      //   this.props.LoadPage('Mst', { mstId: mstId || '_' });
      // }
       if (!(this.props.RBtnTracking || {}).AuthCol || true) {
        this.props.LoadPage('SearchList', { mstId: '!' });
      }      

      if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
        this.props.LoadUserPage('SearchList', { mstId: '!' });
        this.props.LoadUserInitPage({ keyId: null });
      }
    }
    else {
      return;
    }
  }

  componentDidUpdate(prevprops, prevstates) {
    const currReduxScreenState = this.props.VwRUsrSubDtl || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevstates.key !== currMst.key) {
      if ((prevstates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('Mst', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }

  SubmitForm = () => {
    const currMst = ((this.props.RBtnTracking || {}).Mst || {});
    log.debug('currMst', currMst);
    log.debug('parseInt', parseInt(currMst.DnldClickAmt13) + 1);
    this.setState({ key: currMst.key });
    this.props.SavePage(
        this.props.RBtnTracking,
        {
          BtnTrackingId13: currMst.BtnTrackingId13|| '',
          UsrId13: currMst.UsrId13 || ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrId4 || '',
          DnldClickAmt13: (parseInt(currMst.DnldClickAmt13) + 1) || 1,
          ProfClickAmt13: currMst.ProfClickAmt13 || '',
          EntClickAmt13: currMst.EntClickAmt13 || '',
        },
        [],
        {
          persist: true,
          ScreenButton: null,
          OnClickColumeName: null,
        }
      );

     //window.location('https://www.rintagi.com/home/Rintagi_Download/ROComPTYInstall.exe'); 
  }

  render() {
    const notPassedOnboarding = isEmpty(((this.props.RSignUpSurvey || {}).Mst || {}).SignUpSurveyId12);
    if (notPassedOnboarding) {
      return <Redirect to='/' />;
    }

    const VwRUsrSubDtlState = this.props.VwRUsrSubDtl || {};

    if (VwRUsrSubDtlState.access_denied) {
      return <Redirect to='/error' />;
    }

    // if (!VwRUsrSubDtlState.initialized || VwRUsrSubDtlState.page_loading) return null;
    const screenHlp = VwRUsrSubDtlState.ScreenHlp;

    // Labels
    const siteTitle = (this.props.global || {}).pageTitle || '';
    const MasterLstTitle = ((screenHlp || {}).MasterLstTitle || '');
    const MasterLstSubtitle = ((screenHlp || {}).MasterLstSubtitle || '');
    const IncrementMsg = ((screenHlp || {}).IncrementMsg || '');
    const NoMasterMsg = ((screenHlp || {}).NoMasterMsg || '');
    const AddMasterMsg = ((screenHlp || {}).AddMasterMsg || '');
    const MasterFoundMsg = ((screenHlp || {}).MasterFoundMsg || '');

    const screenButtons = VwRUsrSubDtlReduxObj.GetScreenButtons(VwRUsrSubDtlState);
    const screenDdlSelectors = VwRUsrSubDtlReduxObj.ScreenDdlSelectors;
    const screenCriDdlSelectors = VwRUsrSubDtlReduxObj.ScreenCriDdlSelectors;
    const screenCriteria = VwRUsrSubDtlState.ScreenCriteria || {}
    const selectList = VwRUsrSubDtlReduxObj.SearchListToSelectList(VwRUsrSubDtlState);
    const itemList = VwRUsrSubDtlState.Dtl || [];
    const auxLabels = VwRUsrSubDtlState.Label || {};
    const auxSystemLabels = VwRUsrSubDtlState.SystemLabel || {};
    const columnLabel = VwRUsrSubDtlState.ColumnLabel || {};
    const currMst = VwRUsrSubDtlState.Mst;
    const currDtl = VwRUsrSubDtlState.EditDtl;
    const naviBar = getNaviBar('MstList', currMst, {}, screenButtons).filter(v => ((v.type !== 'Dtl' && v.type !== 'DtlList') || currMst.UsrSubsId4));
    const naviSelectBar = getNaviBar('MstList', {}, {}, screenButtons);
    const screenFilterList = VwRUsrSubDtlReduxObj.QuickFilterDdlToSelectList(VwRUsrSubDtlState);
    const screenFilterSelected = screenFilterList.filter(obj => { return obj.key === screenCriteria.FilterId });
    const authRow = (VwRUsrSubDtlState.AuthRow || [])[0] || {};
    const { dropdownMenuButtonList, rowMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    const userId = ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrId4;
    const userPlanId = ((this.props.VwRUsrSubDtl || {}).Mst || {}).ProductId4;
    const userPlanName = (((this.props.VwRUsrSubDtl || {}).ddl || {}).ProductId4 || []).filter(f => f.value === userPlanId).map(m => m.label).toString();
    const freePlan = userPlanId === ' ' || userPlanId === '4' || userPlanId === '1';
    const expireOn = moment(((this.props.VwRUsrSubDtl || {}).Mst || {}).EffectiveTo4).format('MMM Do, YYYY');
    log.debug(userPlanId, userPlanName, freePlan);

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-left'>
              <div className='account__card'>
                <div>
                  <div className='account__head'>
                    {(userPlanId !== '5' && userPlanId !== '6') && <h4 className='account__subhead subhead'>Access our community version of Rintagi to trial the powerful features of the platform. To unlock additional features, <a className="color-blue" href="#/upgrade">upgrade</a> to our professional or enterprise packages.</h4>}
                    {(userPlanId === '5' || userPlanId === '6') && <h4 className='account__subhead subhead'>You are currently on the <span className="color-blue fw-600">{toLower(userPlanName)}</span> plan.</h4>}
                  </div>
                  <div className='w-100'>
                    <Row>
                      <Col>
                        {(userPlanId !== '5' && userPlanId !== '6') && <h4 className='account__title mb-20 fw-600'>Download the latest <span className="color-blue">community</span> version of Rintagi</h4>}
                        {(userPlanId !== '5' && userPlanId !== '6') && 
                          <a href='https://www.rintagi.com/home/Rintagi_Download/ROComPTYInstall.exe'>
                            <Button
                            type='submit'
                            className='btn btn-outline-success rounded account__btn mw-250'
                            onClick={() => {this.SubmitForm()}}>
                            Download</Button>
                          </a>
                        }
                        {(userPlanId === '5' || userPlanId === '6') && <h4 className='account__title mb-20 fw-600'>Download the latest Rintagi package</h4>}
                        {(userPlanId === '5' || userPlanId === '6') && 
                          <a href='https://www.rintagi.com/home/Rintagi_Download/ROProPTYInstall.exe'>
                            <Button
                            type='submit'
                            className='btn btn-outline-success rounded account__btn mw-250'
                            onClick={() => {this.SubmitForm()}}>
                            Download</Button>
                          </a>
                        }
                      </Col>
                    </Row>
                    <div className="mb-20">
                      <p className='account__subhead subhead mb-20 pointer fs-12 d-inline-block mr-20'><a href="https://www.rintagi.com/Docs/site/Initial-Setup/index.html" className="color-light-grey" target="_blank" rel="noopener noreferrer"><u>System Requirements</u></a></p>
                      <p className='account__subhead subhead mb-20 pointer fs-12 d-inline-block'><a href="https://github.com/Rintagi/Low-Code-Development-Platform/releases" className="color-light-grey" target="_blank" rel="noopener noreferrer"><u>All Rintagi Releases</u></a></p>
                    </div>
                    <Row>
                      <Col>
                        <h4 className='account__title fw-600'>Free Resources</h4><br />
                      </Col>
                    </Row>
                    <Row className="row-75 mb-20">
                      <Col sm={12} md={4} className="pointer mb-15 col-75" onClick={() => { window.open('https://www.rintagi.com/Docs/site/index.html'); return false }}>
                        <div className="dashboard-card">
                          <i className="mdi mdi-file-document-box-multiple dashboard-icon d-icon-1"></i>
                          <h4 className='account__subhead subhead text-center'>Read User Guide</h4>
                        </div>
                      </Col>
                      <Col sm={12} md={4} className="pointer mb-15 col-75" onClick={() => { window.open('https://www.rintagi.com/video.aspx'); return false }}>
                        <div className="dashboard-card">
                          <i className="mdi mdi-animation-play dashboard-icon d-icon-2"></i>
                          <h4 className='account__subhead subhead text-center'>View Training Videos</h4>
                        </div>
                      </Col>
                      <Col sm={12} md={4} className="pointer mb-15 col-75" onClick={() => { window.open('https://gitter.im/Rintagi/home'); return false }}>
                        <div className="dashboard-card">
                          <i className="mdi mdi-comment-multiple dashboard-icon d-icon-3"></i>
                          <h4 className='account__subhead subhead text-center'>Ask questions in the community</h4>
                        </div>
                      </Col>
                    </Row>
                    {/* {!freePlan && <Row className="mb-30"> */}
                    <Row className="mb-30">
                      <Col>
                        <h4 className='account__title mb-20 fw-600'>Technical Support</h4>
                        <h4 className='account__subhead subhead mb-20'>Need more support? Contact us by email or phone. Please quote your User ID displayed below.</h4>
                        <h4 className='account__subhead subhead mb-20 fw-600'><i className="mdi mdi-account-card-details plan-id-icon color-rg-blue mr-10"></i>User ID: {userId}</h4>
                        {(!freePlan) && <h4 className='account__subhead subhead mb-20 fw-600'><i className="mdi mdi-clock plan-id-icon color-rg-blue mr-10"></i>License Expires On: {expireOn}</h4>}
                        <Row>
                          {/* <Col className="maxw-170">
                            <h4 className='account__subhead subhead mb-20'><i className="plan-id-icon mdi mdi-phone mr-10"></i>1-800-343-5632</h4>
                          </Col> */}
                          <Col md={6}>
                            <h4 className='account__subhead subhead mb-20'><i className="plan-id-icon mdi mdi-email mr-10"></i><u><a href="mailto:rintagi@robocoder.com">rintagi@robocoder.com</a></u></h4>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  SubTest: state.SubTest,
  global: state.global,
  accountInfo: state.accountInfo,
  plan: state.plan,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
  RSignUpSurvey: state.RSignUpSurvey,
  RBtnTracking: state.RBtnTracking,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    // { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadPage: RBtnTrackingReduxObj.LoadPage.bind(RBtnTrackingReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadSearchList: VwRUsrSubDtlReduxObj.LoadSearchList.bind(VwRUsrSubDtlReduxObj) },
    { SelectMst: VwRUsrSubDtlReduxObj.SelectMst.bind(VwRUsrSubDtlReduxObj) },
    // { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { SavePage: RBtnTrackingReduxObj.SavePage.bind(RBtnTrackingReduxObj) },
    { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { setTopbarMenu: setTopbarMenu },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { registerTopbarLeft: registerTopbarLeft },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);




// WEBPACK FOOTER //
// ./src/pages/Custom/Dashboard.js